// extracted by mini-css-extract-plugin
export default {"wrapper":"GrayBox_wrapper__OeLpl"};